import { cx } from "./cx";

/** 比例条上的一段：start、end 是 0 到 1 的位置，color 用序列色（seriesColor）；current 加描边，表示现在生效的那一段。 */
export interface ShareSegment { key: string; start: number; end: number; color: string; label: string; current?: boolean }

/** 比例条（设计系统 ax-sharebar）：一条 0 到 1 的横轨，画占比或时间轴上的片段，可带一个竖线标记（例如"现在"）与刻度。
 * 颜色只区分片段，含义靠 label：悬停显示，读屏读 aria-label 里的全部片段。 */
export function ShareBar({ label, segments, marker, scale }: { label: string; segments: ShareSegment[]; marker?: { at: number; label: string }; scale?: string[] }) {
  const spoken = [label, ...segments.map((s) => s.label + (s.current ? "（当前）" : "")), marker?.label].filter(Boolean).join("；");
  return (
    <div className="ax-sharebar" role="img" aria-label={spoken}>
      <div className="ax-sharebar-track">
        {segments.map((s) => (
          <span key={s.key} className={cx("ax-sharebar-seg", s.current && "is-current")} title={s.label}
            style={{ left: `${s.start * 100}%`, width: `${Math.max(0, s.end - s.start) * 100}%`, background: s.color }} />
        ))}
        {marker && <span className="ax-sharebar-marker" title={marker.label} style={{ left: `${marker.at * 100}%` }} />}
      </div>
      {scale && <div className="ax-sharebar-scale" aria-hidden>{scale.map((t) => <span key={t}>{t}</span>)}</div>}
    </div>
  );
}
